<template>
  <div class="client" @click="closeDouyinQR">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(i,index) in bannerImg" :key='index'>
          <img :src="i" class="swiperImg">
      </swiper-slide>
    </swiper>
    <!-- <div class="clientCon1" id="clientCon1">
      <div class="clientCon11 contentWidth">
        <div class="clientCon11_left">
          <img src="../../assets/img/client/sb.png" alt="">
          <div class="clientAbout">
            <span class="clientAbout_top">
              ABOUT US
            </span><br>
            <span class="clientAbout_bot">
              关于数聚智连
            </span>
          </div>
        </div>
        <div class="clientCon11_right">
          <span></span>
          <p>
            <span>北京数聚智连科技股份有限公司（原北京蓝色光标电子商务股份有限公司），简称数聚智连，是一家以效果营销驱动销售的整合型品牌运营公司，致力于帮助国内外品牌在中国市场实现品牌爆发。数聚智连作为中国最大的传播集团蓝色光标旗下的电商服务板块。
            </span><br><br>
            <span>总部位于北京，在中国上海、广州、杭州等设有分支机构和香港子公司。</span>
          </p>
        </div>
      </div>
    </div> -->


    <div class="clientCon2" id="clientCon2" style="margin-top:80px;margin-bottom:80px;" data-aos=""  data-aos-duration="1200">
      <div class="clientCon21 contentWidth">
        <div class="clientCon21_left">
          <!-- <div class="clientAbout" :style="'opacity:'+(Con3>=1?'1':'0')"> -->
          <div class="clientAbout">
            <span class="clientAbout_top">
              BRAND SHOW
            </span><br>
            <span class="clientAbout_bot">
              谁选择的我们
            </span>
            <p></p>
          </div>
        </div>
      </div>
    </div>
    <div class="clientCon3">
      <div class="clientConTitleOne contentWidth">
        品效营销类客户
      </div>

      <div v-for='(i,index) in PXYXlogoData' class="clientCon31 contentWidth" style="margin-bottom: 20px;">
        <!-- <h2 data-aos=""  data-aos-duration="1200">{{i.title}}</h2> -->
        <div class="clientCon311" data-aos=""  data-aos-duration="1200">
          <div v-for="(j,item) in i.imgList"  :class="nowClickCrad==j.url?'clientCon311_click_card clientCon311_card':'clientCon311_card'" 
          :style="(j.link||j.douyin?'cursor:pointer;':'')+((item+1)%7==0?'margin-right:0px;':'')">
            <img :src="j.url" alt="" @click.stop='LinkHref(j)'>
            <span :class="j.logo?j.logo+'logo':''">京东</span>
            <div :class="j.douyin==douyin?'douyinQRcode douyinQRcodeMove':'douyinQRcode'">
              <img :src="j.douyin" alt="">
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="clientCon3" id="clientCon3">
      <div class="clientConTitleOne contentWidth">
        销售服务类客户
      </div>
      <!-- <div v-for='(i,index) in XSFWlogoData'  :class="'clientCon31 contentWidth  '+(Con3>=index+2?'clientCon31M':'')"> -->
      <div v-for='(i,index) in XSFWlogoData' class="clientCon31 contentWidth">
        <h2 data-aos=""  data-aos-duration="1200">{{i.title}}</h2>
        <div class="clientCon311" data-aos=""  data-aos-duration="1200">
          <div v-for="(j,item) in i.imgList"  :class="nowClickCrad==j.url?'clientCon311_click_card clientCon311_card':'clientCon311_card'" 
          :style="(j.link||j.douyin?'cursor:pointer;':'')+((item+1)%7==0?'margin-right:0px;':'')">
            <img :src="j.url" alt="" @click.stop='LinkHref(j)'>
            <span :class="j.logo?j.logo+'logo':''">京东</span>
            <div :class="j.douyin==douyin?'douyinQRcode douyinQRcodeMove':'douyinQRcode'">
              <img :src="j.douyin" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ZSelect from '../modules/Zselect'
export default {
  name: 'client',
  components:{ZSelect},
  data () {
    return {
      douyin:'',
      // 当前点击的卡片
      nowClickCrad:'',
      bannerImg:[
        // require('../../assets/img/index/banner202003.png'),
        require('../../assets/img/client/banner1.jpg'),
        require('../../assets/img/client/banner3.jpg'),
        // require('../../assets/img/client/banner5.jpg'),
        // require('../../assets/img/client/banner2.jpg'),
        // require('../../assets/img/client/banner3.jpg'),
        // require('../../assets/img/client/banner4.jpg'),
        // require('../../assets/img/client/banner5.jpg'),
      ],
      test1:'1',
      test2:'1',
      msgs: [{
        ids:1,
        value1:'我是1'
      },{
        ids:2,
        value1:'我是2'
      },{
        ids:3,
        value1:'我是3'
      },{
        ids:4,
        value1:'我是4'
      },],
      swiperOption:{
        loop:true,
        notNextTick: true,
        mousewheelControl: true,
        autoplayDisableOnInteraction:false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        paginationClickable: true,
        autoplay : {
          delay:4000
        },
        observer:true,
        speed:1000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      Con2:0,
      Con1:0,
      Con3:0,
      ImgHover:0,
      
      PXYXlogoData:[
        {
          title:'',
          imgList:[
            {
              url:require('../../assets/img/client/logo/delong1.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/Bolang.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/aojiabao.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/feihe.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/zhuyeqing.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/yapei.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/baojie.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/gongniu.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/pana.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/fengchao.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/xiaopeng.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/xitiecheng.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/xibushuju.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/fujianbenchi.jpg'),
              link:'',
            },
            // {
            //   url:require('../../assets/img/client/logo/zhongjingongsi.jpg'),
            //   link:'',
            // },
            {
              url:require('../../assets/img/client/logo/huifeng.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/tengxun.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/aimu.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/haohuanluo.jpg'),
              link:'',
            },
            {
              url:require('../../assets/img/client/logo/chuangwei.jpg'),
              link:'',
            },
          ]
        }
      ],
      XSFWlogoData:[
        {
          title:'母婴营养 Baby & Nutrition',
          imgList:[
            {
              url:require('../../assets/img/client/logo/yapei.jpg'),
              link:'https://abbott.tmall.com/',
            },
            // {
            //   url:require('../../assets/img/client/logo/yapei1.jpg'),
            //   link:'https://yapei.tmall.com/shop/view_shop.htm?spm=a230r.1.14.5.74bf77aetYhqQ9&user_number_id=2200742079507',
            //   logo:'WZ',
            // },
            {
              url:require('../../assets/img/client/logo/jingzhi.jpg'),
              link:'https://eleva.tmall.com/',
            },
            {
              url:require('../../assets/img/client/logo/meizanchen.jpg'),
              link:'https://meadjohnson.tmall.com/',
            },
            {
              url:require('../../assets/img/client/logo/lanzhen.jpg'),
              link:'https://enfinitas.tmall.com/',
            },
            // {
            //   url:require('../../assets/img/client/logo/qizhi.jpg'),
            //   link:'https://qizhimuying.tmall.com/',
            // },
            // {
            //   url:require('../../assets/img/client/logo/heyangyang.jpg'),
            //   link:'',
            //   // link:'https://list.tmall.com//search_product.htm?spm=a3204.7933263.0.0.68d277d2SGnCj5&cat=50514008&brand=731408835&q=%BA%CC%E3%F3%E3%F3&sort=s&style=g&user_id=725677994,2136152958&from=chaoshi..pc_1_suggest&suggest=0_1&industryCatId=50514008&smAreaId=110100&is=brand',
            // },

            // *****
            {
              url:require('../../assets/img/client/logo/bbs.jpg'),
              link:'https://pampers.tmall.com/',
            },
            {
              url:require('../../assets/img/client/logo/huawang.jpg'),
              link:'https://kao.tmall.com/',
            },
            {
              url:require('../../assets/img/client/logo/gannike.jpg'),
              link:'https://babyganics.tmall.com',
            },
            {
              url:require('../../assets/img/client/logo/jiabao.jpg'),
              link:'https://gerber.tmall.hk',
            },
            // {
            //   url:require('../../assets/img/client/logo/NUK.jpg'),
            //   link:'https://nuk.tmall.com/',
            // },
            // {
            //   url:require('../../assets/img/client/logo/meiguohuieryue.jpg'),
            //   link:'https://crayola.tmall.com/',
            // },
            // 没有连接呢
            {
              url:require('../../assets/img/client/logo/oilatum.jpg'),
              link:'',
            },
            // {
            //   url:require('../../assets/img/client/logo/bebes.jpg'),
            //   link:'https://baobishu.tmall.com/',
            // },

            // *****

            {
              url:require('../../assets/img/client/logo/aojiabao.jpg'),
              link:'https://blackmoresglobal.tmall.hk/',
            },
            {
              url:require('../../assets/img/client/logo/jianmeisheng.jpg'),
              link:'https://jms.tmall.hk',
            },
            {
              url:require('../../assets/img/client/logo/beba.jpg'),
              douyin:require('../../assets/img/client/logo/douyinBeBa.jpg'),
              // link:'https://jms.tmall.hk',
            },
            // {
            //   url:require('../../assets/img/client/logo/gnc.jpg'),
            //   link:'https://mall.jd.hk/index-1000077433.html',
            // },
            // {
            //   url:require('../../assets/img/client/logo/nelo.jpg'),
            //   link:'http://mall.jd.hk/index-1000379541.html',
            // },
            {
              url:require('../../assets/img/client/logo/210531qax.jpg'),
              link:'https://mall.jd.com/index-1000221821.html',
              // logo:'TM',
            },
            {
              url:require('../../assets/img/client/logo/xiaoansu.jpg'),
              link:'https://mall.jd.com/index-1000395593.html',
              // logo:'TM',
            },
            // 没有连接呢
            {
              url:require('../../assets/img/client/logo/feihe.jpg'),
              link:'https://mall.jd.com/index-1000078708.html?from=pc',
            },

            // {
            //   url:require('../../assets/img/client/logo/greenfinger.jpg'),
            //   link:'https://geenfinger.tmall.hk/shop/view_shop.htm',
            // },
            // {
            //   url:require('../../assets/img/client/logo/quanansu.jpg'),
            //   link:'https://mall.jd.com/index-1000221821.html',
            //   logo:'JD',
            // },
            // {
            //   url:require('../../assets/img/client/logo/hasbro.jpg'),
            //   // link:'https://hasbro.tmall.com/',
            //   link:'https://chaoshi.detail.tmall.com/item.htm?spm=a3204.7933263.0.0.4fe01787Qdhazu&id=557295286227&rewcatid=50514008',
            // },
            // {
            //   url:require('../../assets/img/client/logo/water.jpg'),
            //   link:'https://waterwipesmy.tmall.com/',
            // },
            // 没有连接呢
            // {
            //   url:require('../../assets/img/client/logo/210531lh.jpg'),
            //   link:'',
            // },
          ]
        },{
          title:'消费电子 Consumer Electronics',
          imgList:[
            {
              url:require('../../assets/img/client/logo/Oralb.jpg'),
              link:'https://oral-b.tmall.com/',
            },
            {
              url:require('../../assets/img/client/logo/210531sx.jpg'),
              link:'https://mall.jd.com/index-1000003443.html',
            },
            // 没有连接呢
            // {
            //   url:require('../../assets/img/client/logo/210531dl.jpg'),
            //   link:'',
            // },
            // {
            //   url:require('../../assets/img/client/logo/Blueair.jpg'),
            //   link:'https://mall.jd.com/index-1000002484.html',
            // },
            // {
            //   url:require('../../assets/img/client/logo/irobot.jpg'),
            //   link:'https://irobotdq.tmall.com/',
            // },
            {
              url:require('../../assets/img/client/logo/Bolang.jpg'),
              link:'https://braun-hk.tmall.hk/',
            },
            {
              url:require('../../assets/img/client/logo/delong.jpg'),
              link:'https://mall.jd.com/index-1000305463.html',
            },
            {
              url:require('../../assets/img/client/logo/shark.jpg'),
              link:'https://shark.tmall.com/',
            },
            // {
            //   url:require('../../assets/img/client/logo/210531beu.jpg'),
            //   // link:'https://beurershdq.tmall.com/?ut_sk=1.VIpocWBpeW0DAGOmYgSgZ27r_21380790_1622706293449.Copy.shop&weexShopSubTab=shopindex&sourceType=shop&weexShopTab=shopindexbar&suid=C8EB821B-1F59-4A39-AD38-72B548122919&shareUniqueId=10378515032&un=239e91b1d826fff6132b0f6991806569&share_crt_v=1&spm=a2159r.13376460.0.0&sp_tk=Z1h0c1hnZ3FGeFk%3D&cpp=1&shareurl=true&short_name=h.4tVa46u&bxsign=scdaofBPaJ6rLnXQP1TXNneCJg_gE4z1zEyc9m2WmtUSB6fCMst6aWXxl7Gh7hz-T_oBVb_76cC829RksoPbMIKRFKAfc_SDuLkBU-lmGLFM84&sm=0a4a35&app=chrome',
            //   link:'https://beurer.tmall.hk/?spm=a1z10.1-b-s.1997427721.d4918089.82a1f008bUTbMN',
            // },
            {
              url:require('../../assets/img/client/logo/shuer.jpg'),
              link:'https://shuregf.tmall.com/',
            },
            {
              url:require('../../assets/img/client/logo/kaiwude.jpg'),
              link:'https://mall.jd.com/index-1000305443.html',
            },
            // {
            //   url:require('../../assets/img/client/logo/canon.jpg'),
            //   link:'https://mall.jd.com/index-1000000877.html',
            // },
            {
              url:require('../../assets/img/client/logo/weiruan.jpg'),
              link:'https://mall.jd.com/index-1000000326.html',
            },
            // {
            //   url:require('../../assets/img/client/logo/pobling.jpg'),
            //   link:'https://habalan.tmall.hk/',
            // },
            // {
            //   url:require('../../assets/img/client/logo/amd.jpg'),
            //   link:'https://mall.jd.com/index-1000000706.html',
            // },
            {
              url:require('../../assets/img/client/logo/210531wd.jpg'),
              link:'https://mall.jd.com/index-1000000495.html',
            },
            // {
            //   url:require('../../assets/img/client/logo/ABB.jpg'),
            //   link:'https://abb.tmall.com/',
            // },
            // {
            //   url:require('../../assets/img/client/logo/gaotong.jpg'),
            //   link:'https://qualcommsnapdragon.tmall.com/',
            // },
            // {
            //   url:require('../../assets/img/client/logo/BUTTONS.jpg'),
            //   link:'https://mall.jd.com/index-10113135.html',
            // },
            {
              url:require('../../assets/img/client/logo/pana.jpg'),
              link:'https://panasonicghgj.tmall.com/',
            },
            // {
            //   url:require('../../assets/img/client/logo/210531mmj.jpg'),
            //   link:'https://miaomiaoji.tmall.com/',
            // },
            // 没有连接呢
            // {
            //   url:require('../../assets/img/client/logo/210531kin.jpg'),
            //   link:'',
            // },
            // {
            //   url:require('../../assets/img/client/logo/lehuameilan.jpg'),
            //   link:'https://dextergj.tmall.com/',
            // },
            // {
            //   url:require('../../assets/img/client/logo/lehuameilan2.jpg'),
            //   link:'https://lexman.tmall.com/',
            // },
            {
              url:require('../../assets/img/client/logo/boshi.jpg'),
              link:'https://mall.jd.com/index-1000003577.html',
            },
            // {
            //   url:require('../../assets/img/client/logo/weiailun.jpg'),
            //   link:'https://mall.jd.com/index-11709586.html?from=pc',
            // },
          ]
        },
        {
          title:'美妆快消 Beauty & FMCG',
          imgList:[
            {
              url:require('../../assets/img/client/logo/210531osd.jpg'),
              link:'https://mall.jd.com/index-1000002984.html',
            },
            
            {
              url:require('../../assets/img/client/logo/tom.jpg'),
              link:'https://mall.jd.com/index-1000410470.html',
            },
            // {
            //   url:require('../../assets/img/client/logo/210531diro.jpg'),
            //   link:'https://mall.jd.com/index-1000081945.html',
            // },
            {
              url:require('../../assets/img/client/logo/dijiating.jpg'),
              link:'https://mall.jd.com/index-1000009202.html',
            },
            {
              url:require('../../assets/img/client/logo/mulade.jpg'),
              link:'https://mall.jd.com/index-1000445149.html',
            },
            {
              url:require('../../assets/img/client/logo/210531lip.jpg'),
              link:'https://lipsmacker.tmall.com/',
            },
            // {
            //   url:require('../../assets/img/client/logo/wnw.jpg'),
            //   link:'https://wetnwild.tmall.com/',
            // },
            // ******
            {
              url:require('../../assets/img/client/logo/xitiecheng.jpg'),
              link:'https://citizenwatch.tmall.com/',
            },
            {
              url:require('../../assets/img/client/logo/royce.jpg'),
              link:'https://royce.tmall.com/',
            },
            {
              url:require('../../assets/img/client/logo/fulinmen.jpg'),
              link:'https://mall.jd.com/index-1000077335.html',
            },
            {
              url:require('../../assets/img/client/logo/jiaxiangwei.jpg'),
              link:'https://mall.jd.com/index-1000355021.html',
            },
            {
              url:require('../../assets/img/client/logo/jiashibo.jpg'),
              link:'https://carlsberg.tmall.com/',
            },
            {
              url:require('../../assets/img/client/logo/1664.jpg'),
              link:'https://kronenbourg1664.tmall.com/',
            },
            // 没有连接呢
            {
              url:require('../../assets/img/client/logo/yili.jpg'),
              douyin:require('../../assets/img/client/logo/douyinYili.jpg'),
            },
            // 没有连接呢
            {
              url:require('../../assets/img/client/logo/xingbake.jpg'),
              douyin:require('../../assets/img/client/logo/douyinXingBaKe.jpg'),
              link:'',
              // douyin:require('../../assets/img/client/logo/douyinBeBa.jpg'),
            },
            // 没有连接呢
            // {
            //   url:require('../../assets/img/client/logo/210531zyq.jpg'),
            //   link:'',
            // },
            {
              url:require('../../assets/img/client/logo/210531glj.jpg'),
              link:'https://mall.jd.com/index-1000002370.html?from=pc',
            },

            // {
            //   url:require('../../assets/img/client/logo/OLAY.jpg'),
            //   link:'https://mall.jd.com/index-1000002499.html',
            // },
            // {
            //   url:require('../../assets/img/client/logo/tmgj.jpg'),
            //   link:'',
            // },
            // {
            //   url:require('../../assets/img/client/logo/kaimi.jpg'),
            //   link:'https://mall.jd.com/index-1000072623.html',
            // },
            // {
            //   url:require('../../assets/img/client/logo/shaojiboke.jpg'),
            //   link:'https://mall.jd.com/index-1000090908.html',
            // },
            // {
            //   url:require('../../assets/img/client/logo/ludeqing.jpg'),
            //   link:'https://mall.jd.hk/index-842919.html',
            // },
            // {
            //   url:require('../../assets/img/client/logo/mikai.jpg'),
            //   link:'https://mall.jd.com/index-1000072623.html',
            // },
            // {
            //   url:require('../../assets/img/client/logo/jinboli.jpg'),
            //   link:'https://goodfeel.tmall.hk/shop/view_shop.htm',
            // },

            // {
            //   url:require('../../assets/img/client/logo/faith.jpg'),
            //   link:'',//faith
            // },

            // {
            //   url:require('../../assets/img/client/logo/celderma.jpg'),
            //   link:'https://celderma.tmall.com/?spm=a1z10.1-b-s.1997427721.d4918089.1c4856bfN7RGP4',//celderma
            // },
            // {
            //   url:require('../../assets/img/client/logo/zizai.jpg'),
            //   link:'https://freeology.tmall.com/',
            // },
          ]
        },
        // {
        //   title:'食品',
        //   imgList:[
        //     // {
        //     //   url:require('../../assets/img/client/logo/maidong.jpg'),
        //     //   link:'https://mall.jd.com/index-1000008983.html',
        //     // },
        //     // {
        //     //   url:require('../../assets/img/client/logo/wusu.jpg'),
        //     //   link:'https://wusupijiu.tmall.com/',
        //     // },
        //     // {
        //     //   url:require('../../assets/img/client/logo/zhuyeqing.jpg'),
        //     //   link:'',
        //     // },
        //     // {
        //     //   url:require('../../assets/img/client/logo/voss.jpg'),
        //     //   link:'https://vosssp.tmall.com/',
        //     // },
        //     // {
        //     //   url:require('../../assets/img/client/logo/yixiaosheng.jpg'),
        //     //   link:'https://xinshijibjsp.tmall.com/',
        //     // },
        //     {
        //       url:require('../../assets/img/client/logo/citysupe.jpg'),
        //       link:'https://citysuper.tmall.com/',
        //     },
        //     // {
        //     //   url:require('../../assets/img/client/logo/guobeishuang.jpg'),
        //     // },

        //   ]
        // },
        // {
        //   title:'时尚',
        //   imgList:[
            // {
            //   url:require('../../assets/img/client/logo/zghuangjin.jpg'),
            //   link:'https://chinagold.tmall.com/',
            // },
            // {
            //   url:require('../../assets/img/client/logo/ipromise.jpg'),
            //   link:'https://ipromise.tmall.com/',
            // },
        //   ]
        // },
        // {
        //   title:'家装',
        //   imgList:[
        //     {
        //       url:require('../../assets/img/client/logo/ABB.jpg'),
        //       link:'https://abb.tmall.com/',
        //     },
        //     {
        //       url:require('../../assets/img/client/logo/lehuameilan.jpg'),
        //       link:'https://dextergj.tmall.com/',
        //     },
        //     {
        //       url:require('../../assets/img/client/logo/lehuameilan2.jpg'),
        //       link:'https://lexman.tmall.com/',
        //     },
        //   ]
        // },
      ]
      // XSFWlogoData:[
      //   {
      //     title:'3C类',
      //     imgList:[
      //       {
      //         url:require('../../assets/img/client/logo/c1.jpg'),
      //         link:'https://irobotdq.tmall.com/',
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c2.jpg'),
      //         link:'',
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c3.jpg'),
      //         link:'',
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c4.jpg'),
      //         link:'',
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c5.jpg'),
      //         link:'',
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c6.jpg'),
      //         link:'',
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c7.jpg'),
      //         link:'https://mall.jd.com/index-1000003443.html',//三星
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c8.jpg'),
      //         link:'https://mall.jd.com/index-1000000706.html',//AMD
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c9.jpg'),
      //         link:'',//bissell
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c10.jpg'),
      //         link:'',//htc
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c11.jpg'),
      //         link:'',//qualcomm
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c12.jpg'),
      //         link:'https://oral-b.tmall.com/',//Oralb
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c13.jpg'),
      //         link:'https://www.citizen.com.cn/',//西铁城
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c14.jpg'),
      //         link:'https://mall.jd.com/index-1000002484.html',//blurAir
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c15.jpg'),
      //         link:'',
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c16.jpg'),
      //         link:'https://abb.tmall.com/',//ABB
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c17.jpg'),
      //         link:'https://shark.tmall.com/',//shark
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c18.jpg'),
      //         link:'https://mall.jd.hk/index-738498.html',//博朗
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c19.jpg'),
      //         link:'',//亚马逊
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c20.jpg'),
      //         link:'',
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c21.jpg'),
      //         link:'',//佳能
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/c22.jpg'),
      //         link:'https://mall.jd.com/index-1000000495.html',//西部数据
      //       },
      //     ]
      //   },
      //   {
      //     title:'美妆洗护类',
      //     imgList:[
      //       {
      //         url:require('../../assets/img/client/logo/m1.jpg'),
      //         link:'https://wetnwild.tmall.com/',//湿又野
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m2.jpg'),
      //         link:'',//李施德林
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m3.jpg'),
      //         link:'',//嗳呵
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m4.jpg'),
      //         link:'',//佳洁士
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m5.jpg'),
      //         link:'',//珀莱雅
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m6.jpg'),
      //         link:'',//丝芙兰
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m7.jpg'),
      //         link:'',//舒肤佳
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m8.jpg'),
      //         link:'',//宝洁
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m9.jpg'),
      //         link:'',//欧莱雅
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m10.jpg'),
      //         link:'https://mall.jd.com/index-1000072623.html',//开米
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m11.jpg'),
      //         link:'https://mall.jd.hk/index-842919.html',//露得清
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m12.jpg'),
      //         link:'',//潘婷
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m13.jpg'),
      //         link:'https://mall.jd.com/index-1000002984.html',//欧舒丹
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m14.jpg'),
      //         link:'https://lipsmacker.tmall.com/',//LIP
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m15.jpg'),
      //         link:'',//tampa
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m16.jpg'),
      //         link:'',//中美
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m17.jpg'),
      //         link:'',//tampa
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/m18.jpg'),
      //         link:'',//old
      //       },
      //     ]
      //   },
      //   {
      //     title:'母婴类',
      //     imgList:[
      //       {
      //         url:require('../../assets/img/client/logo/y1.jpg'),
      //         link:'',//强生
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/y2.jpg'),
      //         link:'https://pampers.tmall.com/',//帮宝适
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/y3.jpg'),
      //         link:'https://eleva.tmall.com/',//菁智
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/y4.jpg'),
      //         link:'',//飞鹤
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/y5.jpg'),
      //         link:'https://abbott.tmall.com/',//雅培
      //       },
      //     ]
      //   },
      //   {
      //     title:'跨境类',
      //     imgList:[
      //       {
      //         url:require('../../assets/img/client/logo/k1.jpg'),
      //         link:''
      //       },
      //     ]
      //   },
      //   {
      //     title:'汽车类',
      //     imgList:[
      //       {
      //         url:require('../../assets/img/client/logo/q1.jpg'),
      //         link:''
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/q2.jpg'),
      //         link:'',//toyota
      //       },
      //     ]
      //   },
      //   {
      //     title:'快消类',
      //     imgList:[
      //       {
      //         url:require('../../assets/img/client/logo/x1.jpg'),
      //         link:'',//伊利
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/x2.jpg'),
      //         link:'',//亚马逊
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/x3.jpg'),
      //         link:'',
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/x4.jpg'),
      //         link:'https://mall.jd.com/index-1000077335.html',//福临门
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/x5.jpg'),
      //         link:'',//超级波克
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/x6.jpg'),
      //         link:'',//美维仕
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/x7.jpg'),
      //         link:'https://mall.jd.com/index-1000040105.html',//中粮
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/x8.jpg'),
      //         link:'',//雀巢
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/x9.jpg'),
      //         link:'',//GSK
      //       },
      //     ]
      //   },
      //   {
      //     title:'服饰类',
      //     imgList:[
      //       {
      //         url:require('../../assets/img/client/logo/f1.jpg'),
      //         link:'',//
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/f2.jpg'),
      //         link:'',//
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/f3.jpg'),
      //         link:'',//
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/f4.jpg'),
      //         link:'',//
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/f5.jpg'),
      //         link:'',//
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/f6.jpg'),
      //         link:'',//
      //       },
      //     ]
      //   },
      //   {
      //     title:'其他类',
      //     imgList:[
      //       {
      //         url:require('../../assets/img/client/logo/z1.jpg'),
      //         link:'https://chinagold.tmall.com/',//中国黄金
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z2.jpg'),
      //         link:'',//爱奇艺
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z3.jpg'),
      //         link:'https://www.jd.com/',//京东
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z4.jpg'),
      //         link:'',//atlantic beach
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z5.jpg'),
      //         link:'',//罗莱家纺
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z6.jpg'),
      //         link:'',//中国农业科学院
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z7.jpg'),
      //         link:'',//
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z8.jpg'),
      //         link:'',//哲品
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z9.jpg'),
      //         link:'',//lipling
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z10.jpg'),
      //         link:'https://dextergj.tmall.com/',//乐华梅兰
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z11.jpg'),
      //         link:'https://carlsberg.tmall.com/',//嘉士伯
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z12.jpg'),
      //         link:'https://royce.tmall.com/',//royce
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z13.jpg'),
      //         link:'',//likuai
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z14.jpg'),
      //         link:'',//自然之家
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z15.jpg'),
      //         link:'',//
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z16.jpg'),
      //         link:'',//璞谷塘
      //       },
      //       {
      //         url:require('../../assets/img/client/logo/z17.jpg'),
      //         link:'',//SAP
      //       },
      //     ]
      //   },
      // ]
    }
  },
  methods: {
    names(data) {
      console.log(data)
    },
    ImgMouse(data){
      this.ImgHover = data;
    },
    closeDouyinQR(){
      this.douyin = ''
      this.nowClickCrad = ''
    },
    LinkHref(data){
      if(this.nowClickCrad==data.url){
        this.douyin = ''
        this.nowClickCrad = ''
        return
      }else{
        this.douyin = ''
        this.nowClickCrad = ''
      }
      // 当前点击
      this.nowClickCrad = data.url
      if(!data.douyin&&!data.link){
        this.nowClickCrad = ''
      }
      if(data.douyin){
        this.douyin = data.douyin
      }
      if(data.link){
        window.open(data.link);
      }
    }
  },
  mounted(){
    
    // var clientCon2 = document.getElementById('clientCon2')
    // var clientCon1 = document.getElementById('clientCon1')
    // var clientCon3 = document.getElementById('clientCon3')
    // var clientCon2Top = 0;//距离顶部位置
    // var clientCon1Top = 0;//距离顶部位置
    // var clientCon3Top = 0;//距离顶部位置
    // var that = this;
    //   //变量scrollTop是滚动条滚动时，距离顶部的距离
    //   var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
    //   //变量windowHeight是可视区的高度
    //   var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //   //变量scrollHeight是滚动条的总高度
    //   var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
    //   //滚动条到底部的条件
    //   console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight+'元素距离顶部'+clientCon2.offsetTop);
    //   console.log("距顶部"+scrollHeight/windowHeight);
    //   if(scrollHeight/windowHeight<1.3){//如果宽高比不合适就不动画了
    //     that.Con1 = 6;
    //     that.Con2 = 6;
    //     that.Con3 = 9;
    //   }else{
    //     window.onscroll = function(){
    //       //变量scrollTop是滚动条滚动时，距离顶部的距离
    //       var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
    //       //变量windowHeight是可视区的高度
    //       var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //       //变量scrollHeight是滚动条的总高度
    //       var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
    //       //滚动条到底部的条件
          
    //       clientCon2Top = clientCon2.offsetTop-scrollTop;
    //       if(clientCon2Top<700 && clientCon2Top>600){
    //         that.Con2 = 1;
    //       }
    //       else if(clientCon2Top<=600 && clientCon2Top>500){
    //         that.Con2 = 2;
    //       }
    //       else if(clientCon2Top<=500 && clientCon2Top>400){
    //         // that.Con2 = 42.81;
    //         that.Con2 = 3;
    //       }
    //       else if(clientCon2Top<=400 && clientCon2Top>300){
    //         // that.Con2 = 42.81;
    //         that.Con2 = 4;
    //       }
    //       else if(clientCon2Top<=300 && clientCon2Top>200){
    //         // that.Con2 = 42.81;
    //         that.Con2 = 5;
    //       }
    //       else if(clientCon2Top<=200 && clientCon2Top>100){
    //         // that.Con2 = 42.81;
    //         that.Con2 = 6;
    //       }
    //       else if(clientCon2Top<=100){
    //         that.Con2 = 7;
    //       }
    //       else{
    //         that.Con2 = 0;
    //       }
          
    //       clientCon1Top = clientCon1.offsetTop-scrollTop;
    //       if(clientCon1Top<400 && clientCon1Top>300){
    //         that.Con1 = 1;
    //       }
    //       else if(clientCon1Top<=300 && clientCon1Top>200){
    //         that.Con1 = 2;
    //       }
    //       else if(clientCon1Top<=200 && clientCon1Top>100){
    //         that.Con1 = 3;
    //       }
    //       else if(clientCon1Top<=100 && clientCon1Top>0){
    //         that.Con1 = 4;
    //       }
    //       else if(clientCon1Top<=0){
    //         that.Con1 = 5;
    //       }else{
    //         that.Con1 = 0;
    //       }
          
    //       clientCon3Top = clientCon3.offsetTop-scrollTop;
    //       console.log(clientCon3Top);
    //       if(clientCon3Top<900 && clientCon3Top>800){
    //         that.Con3 = 1;
    //       }
    //       else if(clientCon3Top<=800 && clientCon3Top>400){
    //         that.Con3 = 2;
    //       }
    //       else if(clientCon3Top<=400 && clientCon3Top>100){
    //         that.Con3 = 3;
    //       }
    //       else if(clientCon3Top<=100 && clientCon3Top>-200){
    //         that.Con3 = 4;
    //       }
    //       else if(clientCon3Top<=-200 && clientCon3Top>-400){
    //         that.Con3 = 5;
    //       }
    //       else if(clientCon3Top<=-400 && clientCon3Top>-600){
    //         that.Con3 = 6;
    //       }
    //       else if(clientCon3Top<=-600 && clientCon3Top>-900){
    //         that.Con3 = 7;
    //       }
    //       else if(clientCon3Top<=-900 && clientCon3Top>-1100){
    //         that.Con3 = 8;
    //       }
    //       else if(clientCon3Top<=-1100){
    //         that.Con3 = 9;
    //       }
    //       else{
    //         that.Con3 = 0;
    //       }
    //     }
    //   }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less"> 

.client{


  .ceshi{
    display: inline-block;
    width: 7rem;
    height: 3rem;
  }
  .swiperImg{
    width: 100%;
    min-width: 1200px;
  }
  // 第一屏
  .clientCon1{
    .clientCon12{
      height: 580px;
      margin-bottom: 80px;
    }
    // .clientCon12>.clientCon12To:hover .clientCon12Zhe{
    //   opacity: 1;
    // }
    .clientCon12>.clientCon12To{
      display: inline-block;
      font-size: 0;
      overflow: hidden;
      height: 290px;
      width: 25%;
      float: left;
      position: relative;
      img{
        display: block;
        margin: 0;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        position: absolute;
        left: 0;
        top:0;
        z-index: 1;
      }
    }
    .ImgBig{
      transform:scale(1.2);
      -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
    }
    .ImgMix{
      transform:scale(1);
      -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
    }
    .clientCon12>div:nth-of-type(1){
      width: 50%;
    }
    .clientCon12>div:nth-of-type(5){
      width: 50%;
    }
    .clientCon11{
      height: 400px;
      background: #fff;
      .clientCon11_right,.clientCon11_left{
        display: inline-block;
        height: 100%;
        width: 50%;
        float: left;
        border: none;
      }
    }
    .clientCon11_left{
      position: relative;
      img{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        width: 20%;
        animation: insuran11SF 5s;
        -moz-animation: insuran11SF 5s;	/* Firefox */
        -webkit-animation: insuran11SF 5s;	/* Safari 和 Chrome */
        -o-animation: insuran11SF 5s;	/* Opera */
      }
      @keyframes insuran11SF
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-moz-keyframes insuran11SF /* Firefox */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-webkit-keyframes insuran11SF /* Safari 和 Chrome */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-o-keyframes insuran11SF /* Opera */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }
      .clientAbout{
        display: inline-block;
        width: 190px;
        height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        font-size: 38px;
        color: #555;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        animation: swiperRc 3s;
        -moz-animation: swiperRc 3s;	/* Firefox */
        -webkit-animation: swiperRc 3s;	/* Safari 和 Chrome */
        -o-animation: swiperRc 3s;	/* Opera */
        .clientAbout_top{
          display: inline-block;
          width: 100%;
          font-size: 32px;
          font-weight: 900;
        }
        .clientAbout_bot{
          display: inline-block;
          width: 100%;
          font-size: 22px;
          background: url('../../assets/img/client/right.png') no-repeat right;
          font-weight: 900;
        }
      }
    }
    .clientCon11_right{
      position: relative;
      font-size: 14px;
      line-height: 24px;
      color: #555;
      padding:100px 20px;
      box-sizing: border-box;
    }
    .clientCon11_right>span{
      position: absolute;
      left: 0;
      top: 120px;
      display: inline-block;
      background: #0168b7;
      height: 40px;
      width: 4px;
    }
    .clientCon11::after{
      content: '';
      clear: both;
    }
  }
  .swiper-container{//轮播入场
    animation: swiperRc 2s;
    -moz-animation: swiperRc 2s;	/* Firefox */
    -webkit-animation: swiperRc 2s;	/* Safari 和 Chrome */
    -o-animation: swiperRc 2s;	/* Opera */
  }
  @keyframes swiperRc
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-moz-keyframes swiperRc /* Firefox */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-webkit-keyframes swiperRc /* Safari 和 Chrome */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-o-keyframes swiperRc /* Opera */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }
  // 第二屏
  .clientCon2{
    height: 100px;
    margin-top: 0 !important;
    position: relative;
    .clientAbout{
      display: inline-block;
      width: 260px;
      height: 100px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      font-size: 38px;
      color: #555;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
      text-align: center;
      // opacity: 0;
      .clientAbout_top{
        display: inline-block;
        width: 100%;
        font-size: 32px;
        font-weight: 900;
      }
      .clientAbout_bot{
        display: inline-block;
        width: 100%;
        font-size: 22px;
        background: url('../../assets/img/client/down.png') no-repeat 200px;
        font-weight: 900;
      }
      p{
        display: inline-block;
        background: #0168b7;
        width: 40px;
        height: 2px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0 auto;
      }
    }

  }

  // 第三屏
  .clientCon3{
    box-sizing: border-box;
    position: relative;
    .clientConTitleOne{
      height: 40px;
      line-height: 40px;
      background: red;
      font-size: 16px;
      font-weight: 900;
      text-align: center;
      color: #666666;
      background: #c8e1f3;
      letter-spacing:6px;
      margin-bottom: 60px;
    }
    .clientCon31{
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
      filter: blur(0px);
      -webkit-filter:blur(0px);
      position: relative;
      h2{
        font-size: 18px;
        color: #555;
        border-left: 2px solid #0168b7;
        padding-left: 20px;
      }
      .clientCon311{
        position: relative;
        .douyinQRcode{
          display: inline-block;
          width: 100%;
          height: 170px;
          position: absolute;
          background: #fff;
          
          left: 0;
          right: 0;
          top: -148px;
          z-index: 1;
          transform-origin:50% 100%;
          transform:scale(0,0);
          
          transition: all 0.3s;
          -moz-transition: all 0.3s;	/* Firefox 4 */
          -webkit-transition: all 0.3s;	/* Safari 和 Chrome */
          -o-transition: all 0.3s;	/* Opera */
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);

          img{
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .douyinQRcodeMove{
          transform:scale(1.5,1.5);
          -ms-transform:scale(1.5,1.5);     /* IE 9 */
          -moz-transform:scale(1.5,1.5);     /* Firefox */
          -webkit-transform:scale(1.5,1.5); /* Safari 和 Chrome */
          -o-transform:scale(1.5,1.5);
        }
        .WZlogo{
          display: inline-block;
          width: 50%;
          height: 0;
          padding-top: 15%;
          background: #0168b7;
          position: absolute;
          bottom: 0;
          right: 0;
          left: 0;
          margin: auto;
          background: url('../../assets/img/WZlogo.png') no-repeat center;
          background-size: 100% auto;
        }
        .JDlogo{
          display: inline-block;
          width: 23%;
          height: 0;
          padding-top: 23%;
          background: #0168b7;
          position: absolute;
          bottom: 0;
          right: 0;
          left: 0;
          margin: auto;
          background: url('../../assets/img/JDlogo.png') no-repeat center;
          background-size: cover;
        }
        .TMlogo{
          display: inline-block;
          width: 23%;
          height: 0;
          padding-top: 23%;
          background: #0168b7;
          position: absolute;
          bottom: 0;
          right: 0;
          left: 0;
          margin: auto;
          background: url('../../assets/img/TMlogo.png') no-repeat center;
          background-size: cover;
        }
        margin-bottom: 40px;
        div{
          display: inline-block;
          border: 1px solid #f0f0f0;
          margin-left: -1px;
          margin-top: -1px;
          width: 14.3%;
          height: 89px;
          box-sizing: border-box;
          background: #fff;
          position: relative;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .clientCon311_click_card{
          transition: all 0.3s;
          -moz-transition: all 0.3s;	/* Firefox 4 */
          -webkit-transition: all 0.3s;	/* Safari 和 Chrome */
          -o-transition: all 0.3s;	/* Opera */
          border: 1px solid #f0f0f000;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
          z-index: 900;
          transform: scale(1.1);
          -ms-transform:scale(1.1);     /* IE 9 */
          -moz-transform:scale(1.1);     /* Firefox */
          -webkit-transform:scale(1.1); /* Safari 和 Chrome */
          -o-transform:scale(1.1);
        }
        .clientCon311_card:hover{
          // filter: grayscale(100%);
          // -webkit-filter:grayscale(100%);
          transition: all 0.3s;
          -moz-transition: all 0.3s;	/* Firefox 4 */
          -webkit-transition: all 0.3s;	/* Safari 和 Chrome */
          -o-transition: all 0.3s;	/* Opera */
          border: 1px solid #f0f0f000;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
          z-index: 999;
          transform: scale(1.1);
          -ms-transform:scale(1.1);     /* IE 9 */
          -moz-transform:scale(1.1);     /* Firefox */
          -webkit-transform:scale(1.1); /* Safari 和 Chrome */
          -o-transform:scale(1.1);
          // img{
          //   transform:rotateX(360deg);
          //   -ms-transform:rotateX(360deg); 	/* IE 9 */
          //   -moz-transform:rotateX(360deg); 	/* Firefox */
          //   -webkit-transform:rotateX(360deg); /* Safari 和 Chrome */
          //   -o-transform:rotateX(360deg); 	/* Opera */
          //   transition: all 0.5s;
          //   -moz-transition: all 0.5s;	/* Firefox 4 */
          //   -webkit-transition: all 0.5s;	/* Safari 和 Chrome */
          //   -o-transition: all 0.5s;	/* Opera */
          // }
        }
      }
    }
    .clientCon31M{
      filter: blur(0);
      -webkit-filter:blur(0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/client.vue